import React, { Component } from 'react'
import { Search, Grid, Header } from 'semantic-ui-react'
import { Menu } from 'semantic-ui-react'
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom'
import './search.scss';

function sanitise(str = '') {
	return str.replace(' ', '').toLowerCase();
}

export default connect(state => ({menu: state.menu}))(
	withRouter(class SearchExampleStandard extends Component {
		componentWillMount() {
			this.resetComponent()
		}

		resetComponent = () => this.setState({ isLoading: false, results: [], value: '' })

		handleResultSelect = (e, { result }) => {
			this.props.history.push(result.url);
			this.setState({ value: result.title });
		}

		handleSearchChange = (e, { value }) => {
			this.setState({ isLoading: true, value });

			setTimeout(() => {
				if (this.state.value.length < 1) return this.resetComponent();

				const isMatch = result => sanitise(result.title).indexOf(sanitise(this.state.value)) >= 0;

				this.setState({
					isLoading: false,
					results: this.props.menu.map(menu => ({title: menu.title, url: menu.url})).filter(isMatch),
				})
			}, 10)
		}

		render() {
			const { isLoading, value, results } = this.state

			return (
				<Menu.Item>
					<Search
						fluid
						loading={isLoading}
						onResultSelect={this.handleResultSelect}
						onSearchChange={this.handleSearchChange}
						results={results}
						value={value}
						{...this.props}
					/>
				</Menu.Item>
			)
		}
	}
));


// WEBPACK FOOTER //
// ./src/modules/Menu/Search.js